import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "info",
  "use": "info-usage",
  "viewBox": "0 0 3 25.4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 3 25.4\" id=\"info\"><g fill=\"none\" stroke-width=\"3\" stroke-miterlimit=\"10\"><path d=\"M1.5 8.6v16.8M1.5 0v3.4\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol